<kt-splash-screen *ngIf="isLoader"></kt-splash-screen>
<router-outlet></router-outlet>
